import { hsmBackendClient } from './client';
import { IControllerResponse, Subscription } from './types';

/**
 * Cancels a company's HSM subscription (status → inactive). Hits
 * `POST /company/{companyId}/subscription/cancel`. Reversible: activating the
 * subscription again revives it. Returns the updated `Subscription`.
 *
 * @param companyId Target company id.
 */
export async function cancelSubscription(
  companyId: string
): Promise<Subscription> {
  const response = await hsmBackendClient.post<
    IControllerResponse<Subscription>
  >(`/company/${encodeURIComponent(companyId)}/subscription/cancel`);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
